import type { FC, SVGProps } from "react";

type Props = SVGProps<SVGSVGElement>;

/** Shield outline with checkmark — insurance / verified coverage */
const InsuranceIcon: FC<Props> = ({ className, ...props }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
    {...props}
  >
    <path
      d="M12 2.75L5.5 5.5v5.25c0 4.35 2.98 8.42 6.5 9.5 3.52-1.08 6.5-5.15 6.5-9.5V5.5L12 2.75z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M8.75 11.75L10.9 13.9L15.25 9.35"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default InsuranceIcon;
